<template>
    <v-bottom-sheet v-model="show">
        <v-sheet class="text-center" height="200px">
            <div class="title pt-10 pb-5">{{ message }}</div>
            <v-btn color="error"
                   @click="$emit('confirm')"
            >Smazat
            </v-btn>
            <v-btn text
                   @click="$emit('cancel')"
            >Zrušit
            </v-btn>
        </v-sheet>
    </v-bottom-sheet>
</template>
<script>
    export default {
        name: 'DeleteConfirm',
        props: {
            show: Boolean,
            message: {
                type: String,
                default: 'Opravdu chcete smazat vybraný záznam?'
            }
        }
    }
</script>
